import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Header from 'components_library/molecules/Header/Header';
import MobileTabs from 'components_library/molecules/MobileTabs/MobileTabs';
import MoreButton from 'components_library/molecules/MoreButton/MoreButton';
import PageNavigation from 'components_library/molecules/PageNavigation/PageNavigation';
import LoaderSpinner from 'components_v2/common/LoaderSpinner/LoaderSpinner';
import s from './Section.scss';

const MobileSection = props => {
  const {
    children,
    header,
    tabs,
    footer = {},
    onTabsChangeCallback,
    hideMoreStories,
    loading,
    ga,
    typeShemaClassNames,
    paginationData,
    location,
  } = props;

  const [currentPage, setCurrentPage] = useState(1);
  const [moreDataState, setMoreDataState] = useState(undefined);

  const { moreData } = footer;

  const onTabsChange = params => {
    if (
      params &&
      params.clickedItem &&
      params.clickedItem.dataUrl &&
      typeof onTabsChangeCallback === 'function'
    ) {
      onTabsChangeCallback(params.clickedItem.dataUrl, true);
      const footerText =
        params.clickedItem.footerText &&
        typeof params.clickedItem.footerText === 'string'
          ? params.clickedItem.footerText.trim()
          : '';

      if (
        moreData &&
        moreData.enableChangingCTAText &&
        (footerText || params.clickedItem.name) &&
        params.clickedItem.path
      ) {
        setMoreDataState({
          text: footerText || `More ${params.clickedItem.name} News`,
          link: params.clickedItem.path,
        });
      } else {
        setMoreDataState(undefined);
      }
    }
  };

  const loadMoreData = (event, dataUrl) => {
    let nextUrl = dataUrl;
    if (dataUrl && typeof dataUrl === 'string') {
      nextUrl =
        dataUrl +
        (dataUrl.includes('?')
          ? `&curpg=${currentPage + 1}`
          : `?curpg=${currentPage + 1}`);
    }
    setCurrentPage(currentPage + 1);
    event.preventDefault();
    if (typeof onTabsChangeCallback === 'function') {
      onTabsChangeCallback(nextUrl, true, true);
    }
  };

  const isTabsPresent = Array.isArray(tabs) && tabs.length > 1;

  const showPaginationWidget =
    currentPage &&
    currentPage === 1 &&
    paginationData &&
    paginationData.leafNode &&
    paginationData.totalStories &&
    paginationData.storiesPerPage;

  const totalPages = showPaginationWidget
    ? Math.ceil(paginationData.totalStories / paginationData.storiesPerPage)
    : 0;

  return (
    <div className={s.content_wrapper}>
      {loading && <LoaderSpinner />}
      {header &&
        !isTabsPresent && (
          <Header
            {...header}
            ga={ga}
            typeShemaClassNames={typeShemaClassNames}
            isMobile
          />
        )}
      {header &&
        isTabsPresent && (
          <MobileTabs
            header={header}
            tabs={tabs}
            onChangeCallback={onTabsChange}
            showSearchBox
            ga={ga}
            typeShemaClassNames={typeShemaClassNames}
          />
        )}
      {React.isValidElement(children) && children}
      {showPaginationWidget &&
        totalPages > 1 && (
          <PageNavigation
            location={location}
            {...paginationData}
            currentPage={1}
          />
        )}
      {!showPaginationWidget &&
        moreData &&
        moreData.baseUrl &&
        !hideMoreStories && (
          <MoreButton
            isNoLink
            onClick={event => {
              loadMoreData(event, moreData.baseUrl);
            }}
            ga={ga}
            isWapView
            typeShemaClassNames={typeShemaClassNames}
          />
        )}
      {!showPaginationWidget &&
        moreData &&
        !moreData.baseUrl &&
        (moreData.link || (moreDataState && moreDataState.link)) && (
          <MoreButton
            moreText={
              moreDataState && moreDataState.text
                ? moreDataState.text
                : moreData.text
            }
            moreLink={
              moreDataState && moreDataState.link
                ? moreDataState.link
                : moreData.link
            }
            ga={ga}
            isWapView
            typeShemaClassNames={typeShemaClassNames}
          />
        )}
    </div>
  );
};

MobileSection.propTypes = {
  children: PropTypes.node.isRequired,
  header: PropTypes.shape({}),
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      dataUrl: PropTypes.string.isRequired,
    }),
  ),
  footer: PropTypes.shape({
    moreData: PropTypes.shape({
      text: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired,
    }),
  }),
  onTabsChangeCallback: PropTypes.func,
  hideMoreStories: PropTypes.bool,
  loading: PropTypes.bool,
  ga: PropTypes.shape({}),
};

MobileSection.defaultProps = {
  header: null,
  tabs: [],
  footer: {},
  onTabsChangeCallback: () => {},
  hideMoreStories: false,
  loading: false,
  ga: undefined,
};

export default MobileSection;
